import React from 'react'

interface SearchActionButtonIconProps {
  size?: number // Controls width and height
}

const SearchActionButtonIcon: React.FC<SearchActionButtonIconProps> = ({ size = 44 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.3002 2.651C11.7138 2.651 3.10022 11.2646 3.10022 21.851C3.10022 31.8302 10.7562 40.0478 20.5002 40.9598V18.3974L15.7722 23.1254C15.069 23.8286 13.929 23.8286 13.2258 23.1254C12.5226 22.4222 12.5226 21.2822 13.2258 20.579L21.0258 12.779C21.729 12.0758 22.869 12.0758 23.5722 12.779L31.3722 20.579C32.0754 21.2822 32.0754 22.4222 31.3722 23.1254C31.0218 23.4758 30.561 23.6534 30.1002 23.6534C29.6394 23.6534 29.1786 23.4782 28.8282 23.1254L24.1002 18.3974V40.9598C33.8442 40.0478 41.5002 31.8302 41.5002 21.851C41.5002 11.2646 32.8866 2.651 22.3002 2.651Z"
        fill="#673BEC"
      />
    </svg>
  )
}

export default SearchActionButtonIcon
